import { compose, requireScript } from '../../../../src/web/utils/react';
import { widget } from '../../../../src/web/components/widgets/decorators';

import { BUILDER } from '../../../../src/shared/abilities';
import { NAME, ID } from './properties';
import GoogleTranslate from './GoogleTranslate';

const component = compose(
  widget(
    { name: NAME, category: 'Functions', componentId: ID },
    { menu: { items: ['delete'] } },
  ),
  requireScript({
    url: 'https://translate.google.com/translate_a/element.js',
  }),
)(GoogleTranslate);

component.authorization = { action: 'manage', subject: BUILDER };

export default component;
